import { Component } from '@angular/core';

@Component({
  selector: 'rwidget-isic-card-activation-aside',
  templateUrl: './isic-card-activation-aside.component.html',
  styleUrls: ['./isic-card-activation-aside.component.css']
})
export class IsicCardActivationAsideComponent {}
